import { gql } from '@grandvisionhq/graphql';

const shoppinglistPricesFragment = gql`
  fragment ShoppinglistPricesFragment on ProductPrices {
    discountedPrice {
      discountInformation {
        value
      }
      price {
        amount
        currencyCode
      }
    }
    originalPrice {
      amount
      currencyCode
    }
  }
`;
const shoppinglistMediaFragment = gql`
  fragment ShoppinglistMediaFragment on Media {
    images {
      url
    }
  }
`;
const shoppinglistVariantFragment = gql`
  fragment ShoppinglistVariantFragment on Variant {
    ... on AccessoriesVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on ContactLensVariant {
      gan
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on FrameVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on LensTypeVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on PrescriptionGlassesPackageOptionsVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on PrescriptionGlassesPackageVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on ReadyReaderVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on SolutionVariant {
      gan
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on SunglassesVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
  }
  ${shoppinglistMediaFragment}
  ${shoppinglistPricesFragment}
`;
const shoppinglistOverviewFragment = gql`
  fragment ShoppinglistOverviewFragment on Shoppinglist {
    id
    items {
      name
      quantity
      sku
      variant {
        ...ShoppinglistVariantFragment
        sku
        __typename
      }
      product {
        ... on ContactLensProduct {
          id
        }
        slug
      }
    }
  }
  ${shoppinglistVariantFragment}
`;
const ShoppinglistBasicFragment = gql`
  fragment ShoppinglistBasicFragment on Shoppinglist {
    id
    items {
      sku
      product {
        ... on ContactLensProduct {
          id
        }
        slug
      }
    }
  }
`;

export { ShoppinglistBasicFragment, shoppinglistOverviewFragment, shoppinglistVariantFragment };
//# sourceMappingURL=shopping-list.js.map
